/* eslint-disable */
import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MaterialReactTable } from "material-react-table";
import { Checkbox, IconButton, MenuItem, Menu } from "@mui/material";
import DoctorSave from "../../Popup/DoctorSave";

import DoctorDetails from "./Details";
import PrescriptionKPI from "./Kpi"; // Import the KPI component

import * as url from "helpers/urlHelper";


const DoctorList = ({ currentPage, itemsPerPage }) => {

    // loggedin user data
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    const token = localStorage.getItem('token') || '';


    // --- Estados generales ---
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [doctors, setDoctors] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // --- Estados de filtrado ---
    const [searchText, setSearchText] = useState("");
    const [selectedGender, setSelectedGender] = useState("All");
    const [selectedSpecialty, setSelectedSpecialty] = useState("All");
    const [selectedLanguage, setSelectedLanguage] = useState("All");
    const [priceRange, setPriceRange] = useState([0, 4000]);

    // --- Carga inicial de datos ---
    const fetchDoctors = async () => {

        setIsLoading(true);
        try {
            const requestUrl = url.API_DOCTOR_LIST + `&token=${token}`;

            console.log("Fetching doctors from:", requestUrl);

            const { data } = await axios.get(requestUrl);

            if (data.status) setDoctors(data.data);

        } catch (err) {
            console.error("Error al obtener doctores:", err);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        fetchDoctors();
    }, []);

    // --- Handlers de edición / borrado / cierre ---
    const handleEdit = (doc) => {
        setSelectedDoctor(doc);
        setIsEdit(true);
        setShowOffcanvas(true);
    };
    const handleDeleteDoctor = async (id) => {
        if (!window.confirm("¿Seguro que quieres borrar este doctor?")) return;
        try {
            await axios.delete(API_DOCTOR_DELETE(id));
            fetchDoctors();
        } catch (err) {
            console.error("Error borrando doctor:", err);
            alert(`No se pudo borrar el doctor: ${err.response?.data?.message || err.message}`);
        }
    };
    const handleCloseOffcanvas = () => {
        setShowOffcanvas(false);
        setSelectedDoctor(null);
        setIsEdit(false);
        fetchDoctors();
    };

    // --- Filtrado en memoria ---
    const filteredDoctors = useMemo(() => {
        return doctors
            .filter(doc => {
                if (selectedGender === "All") return true;
                return doc.gender?.toLowerCase() === selectedGender.toLowerCase();
            })
            .filter(doc => {
                if (selectedSpecialty === "All") return true;
                return (doc.services || []).some(
                    s => s.toLowerCase() === selectedSpecialty.toLowerCase()
                );
            })
            .filter(doc => {
                if (selectedLanguage === "All") return true;
                return (doc.languages || []).some(
                    l => l.toLowerCase() === selectedLanguage.toLowerCase()
                );
            })
            .filter(doc => {
                const cost = doc.costPerHour ?? 0;
                return cost >= priceRange[0] && cost <= priceRange[1];
            })
            .filter(doc => {
                const full = `${doc.name} ${doc.surname}`.toLowerCase();
                return full.includes(searchText.toLowerCase());
            });
    }, [doctors, searchText, selectedGender, selectedSpecialty, selectedLanguage, priceRange]);

    // --- Definición de columnas para la tabla ---
    const columns = useMemo(
        () => [
            {
                accessorKey: "actions",
                header: "Actions",
                enableSorting: false,
                enableColumnOrdering: false,
                Cell: ({ row }) => {
                    const doc = row.original;
                    const [anchorEl, setAnchorEl] = useState(null);
                    const open = Boolean(anchorEl);
                    return (
                        <>
                            <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
                                ⋮
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={() => setAnchorEl(null)}
                            >
                                <MenuItem onClick={() => {}}>
                                    <i className="bi bi-calendar-event me-2" />
                                    Check Schedule
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        setAnchorEl(null);
                                        handleEdit(doc);
                                    }}
                                >
                                    <i className="bi bi-info-circle me-2" />
                                    Details
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        setAnchorEl(null);
                                        handleDeleteDoctor(doc._id);
                                    }}
                                    sx={{ color: "error.main" }}
                                >
                                    <i className="bi bi-trash me-2" />
                                    Delete
                                </MenuItem>
                            </Menu>
                        </>
                    );
                },
            },
            { accessorKey: "customid", header: "ID" },
            {
                accessorKey: "name",
                header: "Name",
                Cell: ({ row }) => {
                    const d = row.original;
                    return (
                        <div className="col-2 d-flex align-items-center">
                            <img
                                src={d.photo || "https://via.placeholder.com/100"}
                                alt={d.name}
                                style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    marginRight: 8,
                                }}
                            />
                            <div>
                                <div style={{ fontWeight: 600, display: "flex", gap: 8 }}>
                                    <span>{d.name}</span>
                                    <span>{d.surname}</span>
                                </div>
                                <div style={{ fontSize: 14, color: "#666" }}>
                                    {d.position}
                                </div>
                            </div>
                        </div>
                    );
                },
            },
            {
                accessorKey: "phone",
                header: "Phone no.",
                Cell: ({ row }) =>
                    row.original.phone
                        ? row.original.phone.charAt(0).toUpperCase() +
                        row.original.phone.slice(1)
                        : "N/A",
            },
            {
                accessorKey: "email",
                header: "Email",
                Cell: ({ row }) =>
                    row.original.email
                        ? row.original.email.charAt(0).toUpperCase() +
                        row.original.email.slice(1)
                        : "N/A",
            },
            {
                accessorKey: "company",
                header: "Center",
                Cell: ({ row }) =>
                    row.original.company
                        ? row.original.company.charAt(0).toUpperCase() +
                        row.original.company.slice(1)
                        : "N/A",
            },
            {
                accessorKey: "license",
                header: "License no.",
                Cell: ({ row }) => row.original.license || "N/A",
            },
            {
                accessorKey: "experienceInYears",
                header: "Experience",
                Cell: ({ row }) => row.original.experienceInYears || "N/A",
            },
            {
                accessorKey: "availability",
                header: "Availability",
                Cell: ({ row }) => {
                    const slots = (row.original.availability || []).filter(
                        (s) => s.available
                    );
                    if (!slots.length) return "N/A";
                    return (
                        <div>
                            {slots.map((slot, i) => {
                                const day = new Date(slot.date).toLocaleDateString(
                                    "en-US",
                                    { weekday: "long" }
                                );
                                return (
                                    <div key={i}>
                                        <strong>{day}</strong> {slot.startTime}–{slot.endTime}
                                    </div>
                                );
                            })}
                        </div>
                    );
                },
            },
        ],
        []
    );

    return (
          
        <div className="container-fluid px-lg-5">  

                {/* Breadcrumb */}
                <nav className="breadcrumb-container d-none d-md-block pt-3 mb-2" aria-label="breadcrumb">
                    <ol className="breadcrumb fs-sm mb-0">
                        <li className="breadcrumb-item"><Link to="#">Dashboard</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Doctors</li>
                    </ol>
                </nav>

                {/* KPI Component - now receives filtered doctors */}
                <PrescriptionKPI doctors={filteredDoctors} isLoading={isLoading} />

                {/* Tu panel de filtros */}
                <DoctorDetails
                    onSearch={setSearchText}
                    onFilterGender={setSelectedGender}
                    onFilterSpecialty={setSelectedSpecialty}
                    onFilterLanguage={setSelectedLanguage}
                    onFilterRange={setPriceRange}
            />

                {/* La tabla de doctores */}
                <div className="table-wrapper">
                    <MaterialReactTable
                        columns={columns}
                        data={filteredDoctors}
                        state={{ isLoading }}
                        enableRowSelection
                        renderRowSelectionCheckbox={({ row }) => (
                            <Checkbox
                                checked={row.getIsSelected()}
                                indeterminate={row.getIsSomeSelected()}
                                onChange={row.getToggleSelectedHandler()}
                            />
                        )}
                        renderAllRowsSelectionCheckbox={({ table }) => (
                            <Checkbox
                                checked={table.getIsAllRowsSelected()}
                                indeterminate={table.getIsSomeRowsSelected()}
                                onChange={table.getToggleAllRowsSelectedHandler()}
                            />
                        )}
                        enableColumnFilters
                        enableColumnOrdering
                        enableSorting
                        enablePagination
                        muiTableBodyRowProps={{ sx: { backgroundColor: "#ffffffff" } }}
                        muiTableHeadCellProps={{ sx: { backgroundColor: "#ffffffff" } }}
                    />
                </div>

                {/* Offcanvas de crear/editar */}
                <DoctorSave
                    show={showOffcanvas}
                    handleClose={handleCloseOffcanvas}
                    isEdit={isEdit}
                    doctorData={selectedDoctor}
                />
        </div>
    );
};

export default DoctorList;